import {
  Button,
  Box,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Tooltip,
  CardMedia,
} from "@material-ui/core";
import { FaUser, FaEdit, FaTrash } from 'react-icons/fa';
import Search from "@material-ui/icons/Search";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect, useSelector} from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import LabelWithInput from '../components/common/controls/LabelWithInput/LabelWithInput';
// import AddDynamicFields from "../components/common/controls/AddDynamicFields";
import AntSwitch from "../components/common/controls/AntSwitch";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import { sortMoelService } from "../services/ModelsService";
import { uuidv4 } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import { width } from "@fortawesome/free-solid-svg-icons/faSave";
import { LineWeight } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import PersonIcon from '@material-ui/icons/Person'
import SaveIcon from '@material-ui/icons/Save'
import { useHistory } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as CarrierOfficeIcon } from "../assets/images/carrier-office-icon.svg";
import { ReactComponent as DevelopedEconomyIcon } from "../assets/images/developed-economy-icon.svg";
var CONTROLS_DATA = require("./ControlsData.json");

const SalesOffice = ({
  modelState,
  deleteState,
  currencyState,
  createState,
  getModels,
  getRegionsT,
  deleteModel,
  createNewModel,
  updateModel,
  getRegions,
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  getSalesOffice,
  getMarket,
  addNewRegion,
  deleteAdminService,
  updateRegionSalesMarket,
  addNewMarket,
  getCurrency,
  createNewSalesOffice,
  regionId,
  salesOfficeData,
  onModelSelected,
  breadCrumbSettingAction,
  breadCrumbInStore
}) => {
  const [models, setModels] = useState([]);
  //const [regionsT, setRegionsT] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewRegionModel, setShowNewRegionModel] = useState(false);
  const [showNewSalesOfficeModel, setShowNewSalesOfficeModel] = useState(false);
  const [showNewMarketModel, setShowNewMarketModel] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);

  // State Management
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [editData, setEditData] = useState('');
  const [editingType, setEditingType] = useState('');
  const [editId,setEditId] = useState('');
  const onNewProjectClick = () => setShowNewRegionModel(true);
  const [userName, setUserName] = useState("");
  const [marketName, setMarketName] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [isCarrierOffice, setIsCarrierOffice] = useState(false);
  const [isDevelopedEconomy, setIsDevelopedEconomy] = useState(false);
  const [regionSelectedId, setRegionSelectedId] = useState(localStorage.getItem("regionIdValue"));
  const loggedUserRole = localStorage.getItem("loggedinUserRole");
  // Handle Edit Dialog Close
  const handleEditClose = () => {
      setOpenDialog(false);
  };

  // Handle Save after Edit
  const handleEditSave = async(type) => {
    console.log('type in editSave',type);
    if(type === "region"){
      const data = {
        "regionId":editId,
        "regionName":editData
      }
      setLoading(true);
      try{
        await updateRegionSalesMarket(data,type);
        await getRegionsT();
        setSnackBar(true,"success","updated successfully")
        setLoading(false);
        setOpenDialog(false);
      }
      catch(error) {
        setLoading(false);
        setOpenDialog(false);
        setSnackBar(true,"error","Not updated");
        console.log('error in updating the value',error);
      }
    }
    else if(type === "market"){
      const data = {
        "marketId":editId,
        "marketName":editData,
        "salesOfficeId":selectedOffice.salesOfficeId
      }
      setLoading(true);
      try{
        await updateRegionSalesMarket(data,type)
        await getMarket(selectedOffice)
        setSnackBar(true,"success","Market Updated Successfully");
        setLoading(false);
        setOpenDialog(false);
      }
      catch(error){
        setLoading(false);
        setOpenDialog(false);
        setSnackBar(true,"error","Market Not updated");
      }
    }
  };

  //My Use Effect for triple screen
  useEffect(() => { 
    const regionLevelId = {regionId: regionSelectedId}
    const fetchSalesOffice = async () => {
      try {
        if(regionLevelId?.regionId){
        await getSalesOffice(regionLevelId);
      }
      await getCurrency();
      }
      catch (error) {
        console.log('throws error while fetchSalesOffice', error);
      }
    }
    fetchSalesOffice();
  },[getSalesOffice, getCurrency,regionId]);


  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "45% 30% 15% 10%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);


  const isModelPresentInNew = (modelName, selectedModel, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.region == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleAddRegion = async() => {
    console.log('tesing username',userName);
    const data = {
      "regionName":userName
    }
    setLoading(true);
    try{
      await addNewRegion(data);
      await getRegionsT();
      setSnackBar(true,"success","Region add successfully");
      setShowNewRegionModel(false);
      setLoading(false);
    }
    catch(error){
      console.log('error while creating and fetching the region',error);
      setSnackBar(true,"error","Region Not Added SuccessFully");
      setLoading(false);
    }
  }

  const handleAddMarket = async() => {
    const data = {
      "salesOfficeId":selectedOffice.salesOfficeId,
      "marketName":marketName
    }
    setLoading(true);
    try{
      await addNewMarket(data);
      await getMarket(selectedOffice);
      setSnackBar(true,"success","Market add successfully");
      setShowNewMarketModel(false);
      setLoading(false);
    }
    catch(error){
      console.log('error while creating and fetching the region',error);
      setSnackBar(true,"error","Market Not Added SuccessFully");
      setLoading(false);
    }
  }
  
  const handleAddNewSalesOffice = async() => {
    setShowNewSalesOfficeModel(true);
    setLoading(true);
    await getCurrency()
    if(!currencyState?.currency?.isLoading){
      setLoading(false);
    }
  } 

  const handleCreateSalesOffice = async() => {
    if(selectedRegion?.regionId){
      setLoading(true);
      const data = {
        "regionId":selectedRegion?.regionId,
        "isCarrier":isCarrierOffice,
        "salesOfficeName":userName,
        "currencyId":selectedCurrency
      }
      try{
        await createNewSalesOffice(data)
        if(!createState.hasError){
          await getSalesOffice(selectedRegion)
        }
        setSnackBar(true,"success","Sales Office add successfully");
        setShowNewSalesOfficeModel(false);
        setLoading(false);
      }
      catch(error) {
        console.log('create sales office error',error);
        setSnackBar(true,"Error","sales office did not added");
        setShowNewSalesOfficeModel(false);
        setLoading(false);
      }
    }
    else{
      setSnackBar(true,"Error","Please select a region to add sales office !!")
    }
  }

  const handleRegionSelection = (region) => {
    setSelectedRegion(region); 
    setSelectedOffice(null); 
    setSelectedMarket(null);
    getSalesOffice(region);
  }
  const handleSalesOfficeSelection = (sales) => {
    setSelectedOffice(sales);
    setSelectedMarket(null);
    getMarket(sales);
  }
  const history = useHistory();
  //const regionsT = useSelector((state) => state.model.tripleScreen.region ? state.model.tripleScreen.region : []);
  // const salesOfficeData = useSelector((state) => state.model.tripleScreen.sales ? state.model.tripleScreen.sales : []);
  const marketOfficeData = useSelector((state) => state.model.tripleScreen.market ? state.model.tripleScreen.market : []);
  const handleNavigateUsers = async (salesOfficeId) => {
    await onTabSelected(1);
    history.push(`/licenseManager/region/regionsUsers/${salesOfficeId}`);
  };
  
  const navigateToSalesOfficeLevel = async (office) => {
    await onModelSelected("SALES_OFFICE");
    await breadCrumbSettingAction(`${breadCrumbInStore} > ${office.salesOfficeName}`);
    localStorage.setItem("salesOfficeValue",office?.salesOfficeId);
    const currencyObject = currencyState&& currencyState?.data.find(currency => currency.currencyId === office.currencyId);
    localStorage.setItem("currencySymbolValue",currencyObject?.currencySymbol);
    history.push(`/licenseManager/office/customers/${office?.salesOfficeId}`);
  }

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={4} md={9} className="page-content card-content-sales">
        {/* Sales Office Card */}
        {/* {selectedRegion && ( */}
          <div className="card-header-info">
            <Typography variant="h6" className="card-header-typograpy">Sales Offices</Typography>
          </div>
          <Card style={{ minWidth: 275,width:'100%',backgroundColor:'#E5E7ED' }}>
            <CardContent>
              {/* <Typography variant="h6">Offices</Typography> */}
              {salesOfficeData && salesOfficeData.map((office) => {
                const currencyObject = currencyState&& currencyState?.data.find(currency => currency.currencyId === office.currencyId);
                return (
                <div
                  key={office.salesOfficeId}
                  className="btn-cluster-grp"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px',
                    cursor: 'pointer',
                    gap: '8px',
                    borderRadius:'4px',
                    alignItems:"center",
                    marginBottom:"8px",
                    backgroundColor: selectedOffice?.salesOfficeId === office.salesOfficeId ? '#1891F6' : '#FFFFFF',
                  }}
                  onClick={() => 
                    handleSalesOfficeSelection(office)
                  }
                >
                  <Typography>{office.salesOfficeName}</Typography>
                  <Stack direction="row" spacing={2} key={"left"}>
                  <Tooltip id="button-carrier" placement="start-top" title={(office.isCarrier === true) ?"Carrier Office":""}><SvgIcon>{(office.isCarrier === true) ? <CarrierOfficeIcon/>: null}</SvgIcon></Tooltip>
                  <Tooltip id="button-developed" placement="start-top" title={(office.isDevelopedEconomy === true) ?"Developed Economy":""}><SvgIcon>{(office.isDevelopedEconomy === true) ? <DevelopedEconomyIcon/>: null}</SvgIcon></Tooltip>
                  </Stack>
                  <Typography>{currencyObject?currencyObject.currencySymbol: "N/A"}</Typography>
                  <div className="grid-icon">
                    {/*{(loggedUserRole === "REGION")? "":*/}
                      <button className="goto-button"
                          style={{backgroundColor: selectedOffice?.salesOfficeId === office.salesOfficeId ? '#FFFFFF' : '#1891F6',color:selectedOffice?.salesOfficeId === office.salesOfficeId ? '#1891F6' : '#FFFFFF'}}
                          onClick={() => navigateToSalesOfficeLevel(office)}>
                        Go To Sales Office
                      </button>
                    {/*}*/}
                    <div className="grid-action-item-icon-container" key={"right"}>
                       <PersonOutlineOutlinedIcon onClick={()=>{handleNavigateUsers(office.salesOfficeId)}}/> 
                    </div>
                  </div>
                </div>
              )})}
            </CardContent>
          </Card>
        {/* )} */}
      </Grid>
      <Grid container xs={4} md={9} className="page-content card-cotent-market">
        {/* Market Card */}
        {/* {selectedOffice && ( */}
          <div className="card-header-info">
              <Typography variant="h6" className="card-header-typograpy">Markets</Typography>
          </div>
          <Card style={{ minWidth: 275,width:'100%',backgroundColor:'#E5E7ED' }}>
            <CardContent>
              {/* <Typography variant="h6">Markets</Typography> */}
              {marketOfficeData && marketOfficeData.map((market) => (
                <div
                  key={market?.marketId}
                  className="btn-cluster-grp"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px',
                    cursor: 'pointer',
                    gap: '8px',
                    borderRadius:'4px',
                    alignItems:"center",
                    marginBottom:"8px",
                    backgroundColor: selectedMarket?.marketId === market?.marketId ? '#1891F6' : '#FFFFFF',
                  }}
                  onClick={() => setSelectedMarket(market)}
                >
                  <Typography>{market?.marketName}</Typography>
                  <div className="grid-icon">
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        {/* )} */}
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      {/* Add New Region, Sales Office, Market Dialog */}
      <DMModal open={showNewRegionModel} onClose={() => setShowNewRegionModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">New Region</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  style={{float:"right"}}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewRegionModel(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddRegion}
                  //disabled={isDisabled}
                  style={{marginLeft:"10px"}}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal> 
      {/**Add Sales Office Dailog */}
      <DMModal open={showNewSalesOfficeModel} onClose={() => setShowNewSalesOfficeModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">New Sales Office</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <TextField
              id="region-name-select-required-label"
              select
              label={"Currency"}
              variant="outlined"
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              placeholder="Currency"
            >
              {currencyState?.data.map((currency) => {
                return (
                  <MenuItem key={currency.currencyId} value={currency.currencyId}>
                    {currency.currencyName}
                  </MenuItem>
                );
              })}
            </TextField>
            <Grid item className="switch-grid-container">
              <AntSwitch
                checked={isCarrierOffice}
                onChange={() => setIsCarrierOffice(!isCarrierOffice)}
                name={"Status"}
              />
              <Typography style={{ fontSize: "20px" }}>
                Is a Carrier Office
              </Typography>
            </Grid>
            <Grid item className="switch-grid-container">
              <AntSwitch
                checked={isDevelopedEconomy}
                onChange={() => setIsDevelopedEconomy(!isDevelopedEconomy)}
                name={"Status"}
              />
              <Typography style={{ fontSize: "20px" }}>
                Is a Developed Economy
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center",maxWidth:"100%" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  style={{ float: "right" }}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewSalesOfficeModel(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleCreateSalesOffice}
                  //disabled={isDisabled}
                  style={{ marginLeft: "10px" }}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal>
      <DMModal open={showNewMarketModel} onClose={() => setShowNewMarketModel(false)}>
        <div style={modalStyle} className={classes.paper}>
          <h3 id="simple-modal-title">Add Market</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <TextField
              id="outlined-basic-userName"
              label="Name*"
              variant="outlined"
              type="text"
              value={marketName}
              onChange={(e) => setMarketName(e.target.value)}
            />
            <Grid
              item
              xs={9}
              container
              style={{ justifyContent: "center" }}
            >
              <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  style={{float:"right"}}
                  onClick={() => {
                    setIsDisabled(true);
                    setShowNewMarketModel(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddMarket}
                  //disabled={isDisabled}
                  style={{marginLeft:"10px"}}
                  className="makeStyles-gradient-27"
                >
                  OK
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </DMModal>            
      {/**Edit Dialog */}
      <Dialog open={openDialog} onClose={handleEditClose}>
        <DialogTitle>Edit {editingType.charAt(0).toUpperCase() + editingType.slice(1)}</DialogTitle>
        <DialogContent style={{}}>
          <TextField
            label={`${editingType.charAt(0).toUpperCase() + editingType.slice(1)} Name`}
            variant="outlined"
            fullWidth
            value={editData}
            onChange={(e) => setEditData(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} color="primary">Cancel</Button>
          <Button className="saveBtn" onClick={() => handleEditSave(editingType)} color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  salesOfficeData : state.model.tripleScreen.sales || [],
  deleteState: state.model.deleteModel,
  currencyState: state.model.currency,
  createState: state.model.createNewModel,
  breadCrumbInStore: state.misc.bredCrumb
});

const mapDispatchToProps = (dispatch) => {
  return {
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    onModelSelected: async(modelType) => dispatch(miscAction.onModelSelected(modelType)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
    getRegionsT: async() => dispatch(modelAction.getRegionsT()),
    getSalesOffice: async(region) => dispatch(modelAction.getSalesOffice(region)),
    getMarket: async(sales) => dispatch(modelAction.getMarket(sales)),
    getCurrency: async() => dispatch(modelAction.getCurrency()),
    breadCrumbSettingAction: async(breadCrumb) => dispatch(miscAction.breadCrumbSettingAction(breadCrumb))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesOffice);
